import { ModerationLabel } from './types'
import {
  createStatusFilter,
  createModerationLabelFilter,
  createPublishedInFilter,
  createAuthorFilter,
  createLikesFilter,
  createPublicTagFilter
} from './Filters'
import {
  createAuthorColumn,
  createLastEditedColumn,
  createLikesColumn,
  createPublicTagsColumn,
  createPublishDateColumn,
  createPublishedInColumn,
  createStatusColumn,
  createTitleColumn
} from './Columns'
import { ChangeAuthor } from './BulkActions'
/* eslint-disable import/no-internal-modules */
import EmptyPage from '@insided/deprecated-preact-components/empty-page/EmptyPage'
import globals, { ModulesContext } from '@insided/deprecated-utils/globals'
import { ParentCategory } from '@insided/deprecated-preact-components/category-selector/CategorySelector'
import { Module } from '@insided/deprecated-services/modules'
import Overview from '@insided/deprecated-control/overview'

interface Props {
  categories: ParentCategory[]
  moderationLabels: ModerationLabel[]
}

const ArticleOverview = ({ categories, moderationLabels }: Props) => {
  function getFilters() {
    return [
      createStatusFilter(true),
      createPublishedInFilter(categories),
      createModerationLabelFilter(moderationLabels),
      createLikesFilter(),
      createPublicTagFilter(),
      createAuthorFilter()
    ]
  }

  function getColumns() {
    return [
      createTitleColumn(),
      createStatusColumn(),
      createPublishedInColumn(),
      createPublishDateColumn(),
      createAuthorColumn(),
      createLikesColumn(true),
      createLastEditedColumn(),
      createPublicTagsColumn(true)
    ]
  }

  function getBulkActions(modules: Module[]) {
    if (modules.includes('changeAuthorOfPublishedContent')) {
      return [ChangeAuthor]
    }

    return []
  }

  return (
    <ModulesContext.Consumer>
      {(modules) => {
        return (
          <Overview
            type='article'
            headerTitle='Articles'
            withPagination={{
              page: 1,
              pageSize: 25
            }}
            withSorting={{
              lastEditedAt: 'desc'
            }}
            withFilters={getFilters()}
            bulkActions={getBulkActions(modules)}
            withSearch
            searchPlaceholder='Search in title and content'
            withColumns
            rowId='id'
            model={getColumns()}
            endpoint='/article/overview/topics'
            dataKey='topics'
            EmptyStateComponent={
              <EmptyPage
                img_src={`${globals('defaultCdn')}/images/empty_page.png`}
                header='There are no articles yet'
                text={
                  'Seems like no one on your team has created an article. \n Start now by creating a new article.'
                }
                button={{ link: '/content/new/article', text: 'New article' }}
              />
            }
          />
        )
      }}
    </ModulesContext.Consumer>
  )
}

export default ArticleOverview
